import { send } from '../../../../../../../src/network/network';
import { type CustomerRewardCredits } from '../../../../../../../src/types/CustomerRewardCredits';

export async function getApiV2RewardsCustomersCustomerIdRewardCredits() {
  return await send<CustomerRewardCredits>({
    path: `/api/v2/rewards/customers/self/reward_credits/`,
    method: 'GET',
  });
}
